import React from 'react';
import { Link, navigate } from 'gatsby';

import logout from './Logout.png';
import login from './Login.png';
import register from './Register.png';
import account from './Account.png';

const Welcome = ({ user, actions }) => {
    const logoutClick = async e => {
        await actions.userActions.logout();
        window.location.href = '/jamesbondlotterychallenge/logout';
        e.preventDefault();
    };

    const logInLinks = (user, actions) => {
        if (user.loggedIn) {
            return (
                <div>
                    <a
                        href="javascript:void(0);"
                        className="logout"
                        onClick={logoutClick}
                    >
                        <img
                            className="img-responsive"
                            alt="Log Out"
                            src={logout}
                        />
                    </a>
                    <a
                        className="account"
                        href={'/jamesbondlotterychallenge/register'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="img-responsive"
                            alt="My Profile"
                            src={account}
                        />
                    </a>
                </div>
            );
        } else {
            return (
                <div>
                    <Link id="login-btn" className="login" to={'/login'}>
                        <img
                            className="img-responsive"
                            alt="Log In"
                            src={login}
                        />
                    </Link>
                    <a
                        className="account"
                        href={'/jamesbondlotterychallenge/register'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="img-responsive"
                            alt="Register"
                            src={register}
                        />
                    </a>
                </div>
            );
        }
    };

    const renderName = user => {
        if (user.loggedIn) {
            return <p>Welcome, {user.player.first_name}!</p>;
        } else {
            return <p>&nbsp;</p>;
        }
    };

    return (
        <div className="welcome">
            {renderName(user)}
            {logInLinks(user, actions)}
        </div>
    );
};

export default Welcome;
